import React, { useEffect, useState } from "react";
import axiosInstance from "../axios/axios";
import { useNavigate } from "react-router-dom";

const CreateStudentAccount = () => {
  const [name, setName] = useState("");
  const [status, setStatus] = useState("");
  const [degree, setDegree] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [sex, setSex] = useState("");
  const [university, setUniversity] = useState("");
  const [courseOfStudy, setCourseOfStudy] = useState("");
  const [schoolNames, setSchoolNames] = useState([]);

  const route = useNavigate();
  const handleSubmit = (e) => {
    e.preventDefault();

    const userDetails = JSON.parse(localStorage.getItem("formDetails")) || {};
    // Example of handling form data
    const formData = {
      email: userDetails.email,
      password: userDetails.password, // Password shouldn't be handled on the frontend; see suggestions above.
      full_name: name,
      sex,
      role: userDetails.userRole,
      university,
      course_of_study: courseOfStudy,
      status,
      degree,
      phone: mobileNumber,
    };

    console.log("Submitted form data:", formData);
    // Here you can send formData to an API or handle it as required
    axiosInstance
      .post("auth/register", formData)
      .then((response) => {
        console.log(response.data);
        const res = response.data.details;
        localStorage.setItem("user_id", res.user_id);
        localStorage.setItem("role_specific_id", res.id);

        route("/dashboard/jobs");
        // Handle response data as required
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    const fetchSchoolNames = async () => {
      try {
        const response = await axiosInstance.get("schools");
        console.log(response.data);
        setSchoolNames(response.data.data);
      } catch {
        console.log("Error fetching company names");
      }
    };
    fetchSchoolNames();
  }, []);

  return (
    <form
      className="flex flex-col w-full items-center justify-center py-[48px]"
      onSubmit={handleSubmit}
    >
      <section className="flex flex-col gap-2 w-3/4  max-w-[640px]">
        <div className="w-full font-bold text-xl mb-[44px] font-[Be Vietnam Pro]">
          Create a Student Account
        </div>
        <section className="flex flex-col gap-[24px]">
          <div className="flex flex-col w-full">
            <label htmlFor="Email" className="form-label">
              Name
            </label>
            <input
              required
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="custom-form"
              placeholder="Enter your name"
            />
          </div>

          <div className="flex flex-col w-full">
            <label htmlFor="Mobile Number" className="form-label">
              Mobile Number
            </label>
            <input
              required
              type="number"
              value={mobileNumber}
              onChange={(e) => setMobileNumber(e.target.value)}
              className="custom-form"
              placeholder="Enter your Mobile Number"
            />
          </div>
          <div className="flex flex-col w-full">
            <label htmlFor="sex" className="form-label">
              Sex
            </label>
            <select
              id="sex"
              className="custom-form"
              value={sex}
              onChange={(e) => setSex(e.target.value)}
            >
              <option value="" disabled>
                Select your sex
              </option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </select>
          </div>
          <div className="flex flex-col w-full">
            <label htmlFor="status" className="form-label">
              Status
            </label>
            <select
              id="sex"
              className="custom-form"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="" disabled>
                Select your status
              </option>
              <option value="Graduate">Graduate</option>
              <option value="Undergraduate">Undergraduate</option>
            </select>
          </div>
          <div className="flex flex-col w-full">
            <label htmlFor="Email" className="form-label">
              University
            </label>
            <select
              id="university"
              className="custom-form"
              value={university}
              onChange={(e) => setUniversity(e.target.value)}
            >
              <option value="">-- Select your University --</option>
              {schoolNames.map((schoolName) => (
                <option key={schoolName.id} value={schoolName.sc_name}>
                  {schoolName.sc_name}
                </option>
              ))}
            </select>
          </div>
          <div className="flex flex-col w-full">
            <label htmlFor="degree" className="form-label">
              Degree
            </label>
            <select
              id="degree"
              className="custom-form"
              value={degree}
              onChange={(e) => setDegree(e.target.value)}
            >
              <option value="" disabled>
                Select your Degree
              </option>
              <option value="BSc">BSc</option>
              <option value="MSc">MSc</option>
              <option value="HND">HND</option>
              <option value="OND">OND</option>
              <option value="PhD">PhD</option>
            </select>
          </div>
          <div className="flex flex-col w-full">
            <label htmlFor="Email" className="form-label">
              Course Of Study
            </label>
            <input
              required
              type="text"
              value={courseOfStudy}
              onChange={(e) => setCourseOfStudy(e.target.value)}
              className="custom-form"
              placeholder="Enter your Course Of Study"
            />
          </div>
        </section>
        <button
          type="submit"
          className="btn bg-[#049645] hover:bg-[#1E4929] text-white w-full font-bold text-lg my-[24px]"
        >
          Finish
        </button>
      </section>
    </form>
  );
};

export default CreateStudentAccount;
